
(function() {
  var result = { translations: { "en": { "ui": { "UIAbstractPageSection": { "page": "Page Section" }, "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next", "tip": "Use arrow keys to see other items" }, "UIColorSwatch": { "label": "Color picker {{value}}", "noColorLabel": "Color picker, no color selected." }, "UIButtonCollapser": { "dropdownLabel": "Actions" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" }, "UISideNav": { "navigationLandmark": "Secondary" }, "UISortTH": { "ascendingSort": "Ascending sort. Press to sort descending.", "descendingSort": "Descending sort. Press to sort ascending.", "pressToSort": "Press to sort." }, "autosizedTextInput": { "charactersRemaining": "{{value}} characters remaining" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" }, "datePicker": { "dateSelected": "{{date}} is selected.", "noDateSelected": "No date selected.", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date", "invalidDate": "Invalid date", "today": "Today", "clear": "Clear", "placeholder": { "month": "MM", "day": "DD", "year": "YYYY" }, "nextMonth": "Next month", "prevMonth": "Previous month" }, "dateRange": { "startDate": "Start date", "endDate": "End date", "endDateBeforeStartDate": "The end date must come after the start date.", "startDateAfterEndDate": "The start date must come before the end date.", "to": "to" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026and {{count}} more.", "loadMore": "Load more" } }, "salesUI": { "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading\u2026" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" }, "clearButton": "Clear input" }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option \u201C{{label}}\u201D", "plusMore": "+ {{count}} more", "andMore": "\u2026and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } } };
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-3.2754"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.2754",
    "ar-eg": "static-3.2754",
    "bg": "static-3.2754",
    "bn": "static-3.2754",
    "ca-es": "static-3.2754",
    "cs": "static-3.2754",
    "da": "static-3.2754",
    "de": "static-3.2754",
    "el": "static-3.2754",
    "en-gb": "static-3.2754",
    "en": "static-3.2754",
    "es-mx": "static-3.2754",
    "es": "static-3.2754",
    "et": "static-3.2754",
    "fi": "static-3.2754",
    "fr-ca": "static-3.2754",
    "fr": "static-3.2754",
    "he-il": "static-3.2754",
    "hi": "static-3.2754",
    "hr": "static-3.2754",
    "hu": "static-3.2754",
    "id": "static-3.2754",
    "it": "static-3.2754",
    "ja": "static-3.2754",
    "ko": "static-3.2754",
    "lt": "static-3.2754",
    "ms": "static-3.2754",
    "nl": "static-3.2754",
    "no": "static-3.2754",
    "pl": "static-3.2754",
    "pt-br": "static-3.2754",
    "pt-pt": "static-3.2754",
    "ro": "static-3.2754",
    "ru": "static-3.2754",
    "sk": "static-3.2754",
    "sl": "static-3.2754",
    "sv": "static-3.2754",
    "th": "static-3.2754",
    "tl": "static-3.2754",
    "tr": "static-3.2754",
    "uk": "static-3.2754",
    "vi": "static-3.2754",
    "zh-cn": "static-3.2754",
    "zh-hk": "static-3.2754",
    "zh-tw": "static-3.2754"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-3.2754'}); }
})();



(function() {
  var result = { translations: { "en": { "validatedFormControl": { "validationMessageDefaults": { "input": { "validating": "Validating input...", "success": "That input is valid.", "error": "That input isn't valid." }, "email": { "validating": "Validating email address...", "success": "That email address is valid.", "error": "That email address isn't valid." }, "password": { "validating": "Validating password...", "success": "Perfect. The password you entered meets our requirements.", "error": "Sorry. The password you entered does not meet our requirements." }, "url": { "validating": "Validating URL...", "success": "That URL is valid.", "error": "That URL isn't valid." } } } } } };
  result.translationsLoaded = {
  "ui-addon-form-validation": {
    "en": "static-1.6414"
  }
};
  result.translationsAvailable = {
  "ui-addon-form-validation": {
    "af": "static-1.6414",
    "ar-eg": "static-1.6414",
    "bg": "static-1.6414",
    "bn": "static-1.6414",
    "ca-es": "static-1.6414",
    "cs": "static-1.6414",
    "da": "static-1.6414",
    "de": "static-1.6414",
    "el": "static-1.6414",
    "en-gb": "static-1.6414",
    "en": "static-1.6414",
    "es-mx": "static-1.6414",
    "es": "static-1.6414",
    "et": "static-1.6414",
    "fi": "static-1.6414",
    "fr-ca": "static-1.6414",
    "fr": "static-1.6414",
    "he-il": "static-1.6414",
    "hi": "static-1.6414",
    "hr": "static-1.6414",
    "hu": "static-1.6414",
    "id": "static-1.6414",
    "it": "static-1.6414",
    "ja": "static-1.6414",
    "ko": "static-1.6414",
    "lt": "static-1.6414",
    "ms": "static-1.6414",
    "nl": "static-1.6414",
    "no": "static-1.6414",
    "pl": "static-1.6414",
    "pt-br": "static-1.6414",
    "pt-pt": "static-1.6414",
    "ro": "static-1.6414",
    "ru": "static-1.6414",
    "sk": "static-1.6414",
    "sl": "static-1.6414",
    "sv": "static-1.6414",
    "th": "static-1.6414",
    "tl": "static-1.6414",
    "tr": "static-1.6414",
    "uk": "static-1.6414",
    "vi": "static-1.6414",
    "zh-cn": "static-1.6414",
    "zh-hk": "static-1.6414",
    "zh-tw": "static-1.6414"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ui-addon-form-validation:en', {version: 'static-1.6414'}); }
})();



(function() {
  var result = { translations: { "en": { "SharedLegalStrings": { "consent": { "communicationConsentText": "{{ companyName }} is committed to protecting and respecting your privacy, and we\u2019ll only use your personal information to administer your account and to provide the products and services you requested from us. From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick below to say how you would like us to contact you:", "communicationConsentCheckboxes": { "label": "I agree to receive other communications from {{ companyName }}." }, "implicitProcessingConsentText": "By clicking submit below, you consent to allow {{ companyName }} to store and process the personal information submitted above to provide you the content requested.", "explicitProcessingConsentText": "In order to provide you the content requested, we need to store and process your personal data. If you consent to us storing your personal data for this purpose, please tick the checkbox below.", "explicitProcessingConsentCheckboxLabel": "I agree to allow {{ companyName }} to store and process my personal data.", "privacyPolicyText": "You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our Privacy Policy.", "legitimateInterestPrivacyPolicyText": "{{ companyName }} needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please review our Privacy Policy." } } } } };
  result.translationsLoaded = {
  "SharedLegalStrings": {
    "en": "static-1.989"
  }
};
  result.translationsAvailable = {
  "SharedLegalStrings": {
    "af": "static-1.989",
    "ar-eg": "static-1.989",
    "bg": "static-1.989",
    "bn": "static-1.989",
    "ca-es": "static-1.989",
    "cs": "static-1.989",
    "da": "static-1.989",
    "de": "static-1.989",
    "el": "static-1.989",
    "en-gb": "static-1.989",
    "en": "static-1.989",
    "es-mx": "static-1.989",
    "es": "static-1.989",
    "et": "static-1.989",
    "fi": "static-1.989",
    "fr-ca": "static-1.989",
    "fr": "static-1.989",
    "he-il": "static-1.989",
    "hi": "static-1.989",
    "hr": "static-1.989",
    "hu": "static-1.989",
    "id": "static-1.989",
    "it": "static-1.989",
    "ja": "static-1.989",
    "ko": "static-1.989",
    "lt": "static-1.989",
    "ms": "static-1.989",
    "nl": "static-1.989",
    "no": "static-1.989",
    "pl": "static-1.989",
    "pt-br": "static-1.989",
    "pt-pt": "static-1.989",
    "ro": "static-1.989",
    "ru": "static-1.989",
    "sk": "static-1.989",
    "sl": "static-1.989",
    "sv": "static-1.989",
    "th": "static-1.989",
    "tl": "static-1.989",
    "tr": "static-1.989",
    "uk": "static-1.989",
    "vi": "static-1.989",
    "zh-cn": "static-1.989",
    "zh-hk": "static-1.989",
    "zh-tw": "static-1.989"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:SharedLegalStrings:en', {version: 'static-1.989'}); }
})();



(function() {
  var result = { translations: { "en": { "sanitizedEmail": { "imageError": "This image is too large to display.", "expandEmailButtonText": "Expand", "collapseEmailButtonText": "Collapse", "hideEmailRepliesButtonText": "Hide trimmed content", "showEmailRepliesButtonText": "View trimmed content" } } } };
  result.translationsLoaded = {
  "sanitize-text": {
    "en": "static-1.3624"
  }
};
  result.translationsAvailable = {
  "sanitize-text": {
    "af": "static-1.3624",
    "ar-eg": "static-1.3624",
    "bg": "static-1.3624",
    "bn": "static-1.3624",
    "ca-es": "static-1.3624",
    "cs": "static-1.3624",
    "da": "static-1.3624",
    "de": "static-1.3624",
    "el": "static-1.3624",
    "en-gb": "static-1.3624",
    "en": "static-1.3624",
    "es-mx": "static-1.3624",
    "es": "static-1.3624",
    "et": "static-1.3624",
    "fi": "static-1.3624",
    "fr-ca": "static-1.3624",
    "fr": "static-1.3624",
    "he-il": "static-1.3624",
    "hi": "static-1.3624",
    "hr": "static-1.3624",
    "hu": "static-1.3624",
    "id": "static-1.3624",
    "it": "static-1.3624",
    "ja": "static-1.3624",
    "ko": "static-1.3624",
    "lt": "static-1.3624",
    "ms": "static-1.3624",
    "nl": "static-1.3624",
    "no": "static-1.3624",
    "pl": "static-1.3624",
    "pt-br": "static-1.3624",
    "pt-pt": "static-1.3624",
    "ro": "static-1.3624",
    "ru": "static-1.3624",
    "sk": "static-1.3624",
    "sl": "static-1.3624",
    "sv": "static-1.3624",
    "th": "static-1.3624",
    "tl": "static-1.3624",
    "tr": "static-1.3624",
    "uk": "static-1.3624",
    "vi": "static-1.3624",
    "zh-cn": "static-1.3624",
    "zh-hk": "static-1.3624",
    "zh-tw": "static-1.3624"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:sanitize-text:en', {version: 'static-1.3624'}); }
})();



(function() {
  var result = { translations: { "en": { "a11y": { "viewSpecificPage": "Now displaying page {{ pageNumber }}", "hiddenPDFControls": "Navigate between pages of this document", "previousPage": "Go to previous page", "nextPage": "Go to next page", "pageSelectorButton": "Page {{ pageNumber }}", "pageSelectorContainer": "Select a page", "senderProfile": "Book a meeting or send an email to {{ email }}", "downloadButton": "Download this document to your computer", "shareButton": "Access a shareable link for this document", "skipToDocument": "Skip links to display main content.", "brandingAltTextNoCompany": "Company logo", "brandingAltText": "{{ companyName }} logo" }, "app": { "htmlTitle": "Documents | HubSpot", "title": "Documents" }, "view": { "notAvailable": "This document is temporarily unavailable. Try again after {{ date }}.", "notFound": "But that page is nowhere to be found", "error": "Sorry, looks like the document you were looking for is unavailable.", "toolbar": { "download": "Download", "share": "Share", "shareThisLink": "Share this link", "sender": { "meetingsLink": "Let's meet", "emailLink": "Email me" }, "addLogo": "Add your logo" }, "viewerInfo": { "header": { "title": { "withName": "{{ name }} shared this document with you.", "noName": "Someone shared this document with you." }, "subtitle": "Please enter your email address to continue" }, "submit": "Submit" }, "previewAlert": { "title": "Preview - do not share this page", "description": "To send a tracked link, return to the {{ documentSummaryLink }}.", "documentSummaryLink": "document summary" }, "utm": { "shareYourFiles": "This document was shared using", "getHubSpotFree": "Try HubSpot for free" }, "gdprSubmissionError": { "title": "There was a problem submitting the form.", "message": "Please refresh the page and try again. If the problem persists, contact the document owner." } }, "pdf": { "error": { "errorTitle": "Well, this is disappointing", "errorDescription": "Sorry, looks like the document you were looking for is unavailable.", "tryAgain": "Refresh and try again" }, "controls": { "page": "Page {{ pageNumber }} of {{ totalPages }}" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "documents-lib": {
    "af": "static-1.9097",
    "ar-eg": "static-1.9097",
    "bg": "static-1.9097",
    "bn": "static-1.9097",
    "ca-es": "static-1.9097",
    "cs": "static-1.9097",
    "da": "static-1.9097",
    "de": "static-1.9097",
    "el": "static-1.9097",
    "en-gb": "static-1.9097",
    "en": "static-1.9097",
    "es-mx": "static-1.9097",
    "es": "static-1.9097",
    "et": "static-1.9097",
    "fi": "static-1.9097",
    "fr-ca": "static-1.9097",
    "fr": "static-1.9097",
    "he-il": "static-1.9097",
    "hi": "static-1.9097",
    "hr": "static-1.9097",
    "hu": "static-1.9097",
    "id": "static-1.9097",
    "it": "static-1.9097",
    "ja": "static-1.9097",
    "ko": "static-1.9097",
    "lt": "static-1.9097",
    "ms": "static-1.9097",
    "nl": "static-1.9097",
    "no": "static-1.9097",
    "pl": "static-1.9097",
    "pt-br": "static-1.9097",
    "pt-pt": "static-1.9097",
    "ro": "static-1.9097",
    "ru": "static-1.9097",
    "sk": "static-1.9097",
    "sl": "static-1.9097",
    "sv": "static-1.9097",
    "th": "static-1.9097",
    "tl": "static-1.9097",
    "tr": "static-1.9097",
    "uk": "static-1.9097",
    "vi": "static-1.9097",
    "zh-cn": "static-1.9097",
    "zh-hk": "static-1.9097",
    "zh-tw": "static-1.9097"
  }
};
  hns('I18n', result);

})();


